module.exports = __webpack_public_path__ + "static/btn 2_00002.1dde0d23.png";